import { queueTrackingEvent } from '@library/tracking-integration'
import { DeliveryEligibility } from './types'

export enum TrackingActions {
  NDD_BANNER_TIMER = 'ndd_banner_timer',
}

export enum BannerLocations {
  DELIVERY_DAYS = 'delivery_days',
  BOX_SUMMARY = 'box_summary',
}

type NDDBannerTimerTrackingData = {
  action: TrackingActions.NDD_BANNER_TIMER
  properties: {
    offer: DeliveryEligibility | null
    time_left?: string
  }
}

export function trackNDDBannerTimer(
  offerType: DeliveryEligibility | null,
  timeLeftInMinutes: string | number | null | undefined,
) {
  const isValidTimeLeft =
    timeLeftInMinutes != null && timeLeftInMinutes !== '' && !isNaN(Number(timeLeftInMinutes))

  queueTrackingEvent<NDDBannerTimerTrackingData>({
    action: TrackingActions.NDD_BANNER_TIMER,
    properties: {
      offer: offerType,
      ...(isValidTimeLeft && { time_left: String(timeLeftInMinutes) }),
    },
  })
}
